export default __webpack_public_path__ + "static/media/Aula5.a9fc4d50.jpeg";